import { REFERENCE_FPS, Vector2 } from '@cgs/wge';
import { EntitiesEngine } from '../../entities_engine/entities_engine';
import { Entity } from '../../entities_engine/entity';
import { EntityCacheHolder } from '../../game_components/entity_cache_holder';
import { MovementSystem } from '../../systems/movement_system';

export class FreeFallMovementSystem extends MovementSystem {
  constructor(engine: EntitiesEngine, entityCacheHolder: EntityCacheHolder) {
    super(engine, entityCacheHolder);
  }

  processEntity(entity: Entity, dt: number): void {
    const position: Vector2 = entity.get(this.positionIndex);
    const velocity: Vector2 = entity.get(this.speedIndex);
    const timeFactor = dt * REFERENCE_FPS;

    position.x += velocity.x * timeFactor;
    position.y += velocity.y * timeFactor;
    entity.set(this.positionIndex, position);
  }
}
